var $j = jQuery.noConflict();
$j(document).ready(function(){
  if($('.template-product.lipstick-landing').length == 0 && $('.default_product_template').length == 0 ){
  if($j('.slider_custome').length) {
    $j('.slider_custome').slick({
          dots: true,
          adaptiveHeight: true,
          swipe: true,
          appendDots: $j('#ProductThumbs-product , #ProductThumbs-productt'),
          customPaging:function(slider, i) {
            var thumb = $j(slider.$slides[i]).data('thumb');
            
            if($j('[data-thumb="'+ thumb +'"]').hasClass('pro_video')){
              return '<div class="abcontainer"><img class="ab" src="'+thumb+'"><span class="play_icon"></span></div>';
            }else{
              return '<div class="abcontainer"><img class="ab" src="'+thumb+'"></div>';
            }
          }
        });
    }
  }else{
      function ensureSecondDotsContainer() {
        if (!$j('#ProductThumbs-productt').length) {
            $j('#ProductThumbs-product').after('<div id="ProductThumbs-productt"></div>');
        }
      }

      function cloneDots() {
        ensureSecondDotsContainer();
        console.log($j('#ProductThumbs-product'))
        var dots = $j('#ProductThumbs-product .slick-dots').clone(true);
        $j('#ProductThumbs-productt').html(dots);
      if(document.querySelector('#ProductThumbs-productt .slick-dots')){
        var current_dots = document.querySelector('#ProductThumbs-productt .slick-dots').offsetWidth;
        var divide_width = current_dots / 2 + 40;
        if(document.querySelector('.slider_custome .slick-next') != null){
        document.querySelector('.slider_custome .slick-prev').style.left = 'calc(50% - '+ divide_width +'px)';
        document.querySelector('.slider_custome .slick-next').style.right = 'calc(50% - '+ divide_width +'px)';
        }
        }
        if(document.querySelector('.product-single__photo-wrapper1.slick-active:has(video)')){
          document.querySelector('.product-single__photo-wrapper1 video').play();
        }
        if(!document.querySelector('.product-single__photo-wrapper1.slick-active:has(video)') && document.querySelector('.product-single__photo-wrapper1 video')){
          document.querySelector('.product-single__photo-wrapper1 video').pause();
        }

        if($('#ProductThumbs-productt').length){
     var current_height = $('.slider_custome').height() + 10;
      document.querySelector('#ProductThumbs-productt .slick-dots').style.setProperty('top', current_height + 'px', 'important');
        }
      }


      $j('.slider_custome')
      .on('init', function(){
        cloneDots();
      })
      .on('reInit', function(){
        cloneDots();
      })
      .on('afterChange', function(){
        cloneDots();
      });

      $j(document).on('variant:change', function(){
        setTimeout(function(){
            cloneDots();
        }, 400);
      });

      $j('.slider_custome').slick({
          dots: true,
          adaptiveHeight: true,
          swipe: true,
          appendDots: $j('#ProductThumbs-product'),
          customPaging:function(slider, i) {
              var thumb = $j(slider.$slides[i]).data('thumb');
              
              if($j('[data-thumb="'+ thumb +'"]').hasClass('pro_video')){
                  return '<div class="abcontainer"><img class="ab" src="'+thumb+'"><span class="play_icon"></span></div>';
              } else {
                  return '<div class="abcontainer"><img class="ab" src="'+thumb+'"></div>';
              }
          }
      });
  }

  
 //  single image hide arrow
  hide_single_img();
 
  // swipe
  if($j('.product-single__photos .product-single__photo-wrapper').length) {
  $j('.product-single__photos .product-single__photo-wrapper').touchwipe({
    
    
            wipeRight: function() { mob_swipe(2);},
            wipeLeft:  function() { mob_swipe(1);},            
             min_move_x: 60   
    
 });
  }
 
  
  function mob_swipe(next_prev)
  {
    if(next_prev==1)
    {     
         $('.thumbnails-wrapper ul.product-single__thumbnails li a.active-thumb').parents('li').next('li').children('a').trigger('click');
      hide_single_img();
    
    }
   
    if(next_prev==2)
    {
        $('.thumbnails-wrapper ul.product-single__thumbnails li a.active-thumb').parents('li').prev('li').children('a').trigger('click');
       hide_single_img();
    }
  
  
  }
 
  
  
 	 product_img_padidng_top();
	 product_thumb_img();
  
  
  
  listhide_arrow()
  function listhide_arrow()
  { 
     
    if($j('.thumbnails-wrapper ul.product-single__thumbnails li:last-child a').hasClass('active-thumb')){
     $j('.next_product').hide();
      var pev = $j('.thumbnails-wrapper ul.product-single__thumbnails li:last-child').parents('li');
     if(typeof pev != 'undefined') {
        $j('.pre_product').show();
      }
    }
  }
  
//    if($(window).width()<=749){
//    console.log('cdcd')
// if($j(".lipstick-landing .related-product .grid--uniform").length){
//   $j('.lipstick-landing .related-product .grid--uniform').each(function(slider___slider) {
//       $j(this).slick({
//         dots:true,
//       infinite: false,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//         arrows:false
//     });
//   });
// }
//   }  

  // contact form
  
  $j('body').on('change', 'form.esc--form select', function(){
   if( $j(this).find(":selected").html() =='order enquiry')     
   {
     $j('.order_no').show();
      $j('.order_no input').attr('required', 'required');
   }
    else
    {
      $j('.order_no').hide();
      $j('.order_no input').removeAttr('required');
    }
  });
  $j('body').on('click, focus', 'form.esc--form .order_no', function(){
  	//$j(this).find('input').attr('type', 'number');
  });
   $j('body').on('focusout', 'form.esc--form .order_no', function(){
     //	$j(this).find('input').attr('type', 'text');
   });
  
 
  
  
 
  var dropdow =$j('.drop_down_color_box').height();
  if(dropdow > 250)
  {
    $j('.drop_down_color_box').css('overflow-y', 'scroll');
  }else
  {
    $j('.drop_down_color_box').css('overflow', 'hide');
  }
  
  
 $j('.login_popup').slideToggle();
  
   setTimeout(function(){ 
 	  $j('.login_popup').css('opacity', '1');
  }, 3000);
 
  // product slider
  product_img_slider();
  
  //show product icon
  if($j('.product_select_first_available').html() != '')
  {
   hide_show_thumb_img($j('.product_select_first_available').html());
   
  }
  if($j('.product_select_first_available_title').html() != '')
  {
    hide_show_varaint_txt($j('.product_select_first_available_title').html());
  }
  // eyeshadow pallete
  $j('.eyes_shadow_box .drop_down_color_box li').each(function(){
    
    var a = $j(this).find('.single_color_box_outer').children('.single_color_box').length;
    
    
    	$j(this).find('.single_color_box_outer').children('.single_color_box').each(function(){
          	$j(this).css('width', 100/a+'%');
        });
  });
  
  $j('.header_txt_account spna').click(function(){
    	if(!$j(this).hasClass('active'))
        {
          $j(this).addClass('active');
          
         // $j('.login_popup').slideToggle();
          $j('.login_popup').fadeIn('fast');
          $j('.full_scree_fade').fadeIn('fast');
         
           $j('#min-cart').children('.cart_popup').hide();
           $j('#min-cart #min-cart_a').removeClass('active');
          $j('#SiteNav').addClass('header_active');
          
        }
    	else
        {
           $j(this).removeClass('active');
           //$j('.login_popup').slideToggle();  
           $j('.login_popup').fadeOut('fast');
           $j('.full_scree_fade').fadeOut('fast');
          
           $j('#SiteNav').removeClass('header_active');
        }
      
  });
  // min-cart
  $j('#min-cart #min-cart_a').click(function(e){ 
  
    if(!$j('body').hasClass('template-cart')){      
     
        
    //  
      if(!$j(this).hasClass('active'))
        {

          $j(this).addClass('active'); 
          // CD CODE
          cart_refresh();
          $('.cart_drawer').addClass('is_open');
          setTimeout(function() {
          $('#giftbox-root').addClass('is_open');
            }, 500);
          //$j('.cart_popup').slideToggle(); 
          // $j('.cart_popup').fadeToggle('fast');
          // $j('.full_scree_fade').fadeIn('fast');
          $j('.login_popup').hide();         
          $j('.header_txt_account spna').removeClass('active');
          $j('#SiteNav').addClass('header_active');
        }
      else
          {
          if($j(window).width() < 768)
    {
      return;  
    } 
             //$j('.cart_popup').slideToggle();
             // $j('.cart_popup').fadeToggle('fast');
             $j(this).removeClass('active');            
             // $j('.full_scree_fade').fadeOut('fast');
             $j('#SiteNav').removeClass('header_active');
          }
   		
    	e.preventDefault();
    
    }
    
  });
  
  $j('.full_scree_fade').click(function(){
    	if($j('#min-cart #min-cart_a').hasClass('active'))
           {
            $('#min-cart #min-cart_a').trigger('click');
           }
          if($j('.header_txt_account spna').hasClass('active'))
          {             
                   $('.header_txt_account spna').trigger('click');
          }
  });

  $j('.full_scree_fade_footer').click(function(){
    $j('.full_scree_fade_footer').stop().fadeOut();
    $j('#current_currency_value').removeClass('active');
    $j('.currency_convert_box').stop().slideToggle('fast');
    $j('.currency_convert_box').removeClass('active');
	remove_effict();
  });
  
  
  // currency
  $j('.currency_convert_box li.top_header').click(function(){
   // $j('.full_scree_fade_footer').fadeOut();
    //$j('.currency_convert_box').slideToggle();
  });
  
  $j('.currency_convert_box li').click(function(){
    if(!$j(this).hasClass('top_header')){
    	var c_code = $j(this).children('.curry_code').html(); 
    $j('.currency_convert_box li.active').removeClass('active');
    
    
      
    $j(".currency-picker option").each(function(){
          if($j(this).val()==c_code.trim()){ 
              $j(this).attr("selected","selected");  
           
          }else{
           $j(this).removeAttr( "selected" );
          }
      });
   
      $j('.currency_convert_box').stop().slideToggle('fast');
      $j('#current_currency_value').html($j(this).html());
      $j('.full_scree_fade_footer').stop().fadeOut(); 
      $j(this).addClass('active');
      $j('#current_currency_value').removeClass('active');
      var newCurrency = jQuery(".currency-picker").val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      jQuery('.selected-currency').text(Currency.currentCurrency);   
  	}
    else
    {
       $j('.full_scree_fade_footer').stop().fadeOut();
       $j('.currency_convert_box').stop().slideToggle('fast');
      $j('#current_currency_value').removeClass('active');
      
    }
    
    $j('.currency_convert_box').removeClass('active');
    remove_effict();
  });
  
  
  
  var current_currency =  $j(".currency-picker").val();
  $j('.currency_convert_box li').each(function(){
    	var livalue = $j(this).children('.curry_code').html();
    	if(current_currency == livalue)
        {
          $j('#current_currency_value').html($j(this).html());
          return false;
        }
  });
  $j('#current_currency_value').click(function(){
   		if(!$j(this).hasClass('active'))
        {
          $j('.currency_convert_box').stop().slideToggle('fast');
          $j('.currency_convert_box').addClass('active');
          if($j(window).width() > 768){
          	$j('.full_scree_fade_footer').stop().fadeIn();
          }
          
          $j(this).addClass('active');
           setTimeout(function(){ 
              remove_effict();
          }, 100);
        }
    	else
        {
            $j('.currency_convert_box').stop().slideToggle('fast');
            $j
            $j('.full_scree_fade_footer').stop().fadeOut();
            $j(this).removeClass('active');
          
          	setTimeout(function(){ 
                $j('.currency_convert_box').removeClass('active');
            }, 100);
          
            remove_effict();
        }
    
   
    
    
  });
  
  
  
  
  /*setInterval(function(){ 
     if($j('.BOLD-mc-picker').hasClass('open')){          
       		$j('.full_scree_fade_footer').fadeIn();
 		 }
    else
    {       
       $j('.full_scree_fade_footer').fadeOut(); 
    }
  		
  		
  }, 100); */
    
 
  
  var place_hld;
 $j("input[type='text'], input[type='email'], input[type='password'], textarea").on("focus", function(){
  place_hld = $j(this).attr("placeholder");
  $j(this).attr("placeholder", "");
 });
 $j("input[type='text'], input[type='email'], input[type='password'], textarea").on("focusout", function(){
  $j(this).attr("placeholder", place_hld);
 });
  
  
  
  // color option
   $j(".swatch :radio").change(function(e) {  
    
       var i = $j(this).closest(".swatch").attr("data-option-index"),
       t = $j(this).val(); 
      var t2= $j(this).attr('data-vare-input');
      $(this).closest("form").find(".single-option-selector").eq(i).val(t).trigger("change");
     $j('.swatch label').removeClass('active');
     $j(this).next().addClass('active');
     // $j('.selected_value').html(t);
     select_dp_option(t,$j(this));
    // select_parent_cat(t);
     
     
     /// product variant text show
      /* t = t.replace(" - ", "-");
       t = t.replace(/ /gi, "-"); */
       
      t = t.toLowerCase(); 
      hide_show_varaint_txt(t2);   
     
     // hide_show_thumb_img(t2);
     var getts = $j(this).attr('data-varent');  
      reset_slider(getts);
     
   });
  
    $(".single-option-selector").change(function() { 
			var t= $j(this).val(); 
      
       $j(".swatch input[value='"+t+"']").prop("checked", true);
       $j('.swatch label').removeClass('active');
     $j(".swatch input[value='"+t+"']").next().addClass('active');    
      
     console.log('csllllllll')
      if($j(this).parents(".grid-action").length !== 0) {
        grid_variant_change($j(this),t);
      }
    });
  
   var t=  $j(".single-option-selector").val();
    $j(".swatch input[value='"+t+"']").prop("checked", true);
    $j('.swatch label').removeClass('active');
    $j(".swatch input[value='"+t+"']").next().addClass('active');  
    
  select_dp_option(t, $j('.swatch_box'));
  
  // $j('.selected_value').click(function(){ 
  //   var $this = $j(this);
  //   var $color_box = $this.parent('div').find('ul.drop_down_color_box')
  //   $color_box.stop().slideToggle('fast');
  //   var widow_w=$j(window).width();
    
  //   if($color_box.hasClass('active')){
      
  //      $color_box.removeClass('active');
  //   }else
  //   {
  //     $color_box.addClass('active');
  //   }
    
    
  //   if(widow_w<769){
  //     if($this.hasClass('active'))
  //     {
  //       $j('body').removeAttr('style');
       
  //         $this.removeClass('active');
  //     }
  //     else
  //     {
  //       if($this.parents(".grid-action").length === 0) {
  //        if($this.parents(".eyes-shadow-wrap.visible-sm").length === 0) { $j('body').css('position', 'fixed'); }
  //        $this.addClass('active');
  //       }
  //     }
  //   }
    
  // });

  $j('.selected_value').click(function(){ 
  var $this = $j(this);
  var $color_box = $this.parent('div').find('ul.drop_down_color_box');

  $j('ul.drop_down_color_box').not($color_box).slideUp('fast').removeClass('active');
  $j('.selected_value').not($this).removeClass('active');

  $color_box.stop().slideToggle('fast').toggleClass('active');

  var widow_w = $j(window).width();

  if(widow_w < 769){
    if($this.hasClass('active')){
      $j('body').removeAttr('style');
      $this.removeClass('active');
    } else {
      if($this.parents(".grid-action").length === 0) {
        if($this.parents(".eyes-shadow-wrap.visible-sm").length === 0) {
          $j('body').css('position', 'fixed');
        }
        $this.addClass('active');
      }
    }
  }
});
  
 /* $j('ul.drop_down_color_box li').click(function(){
    
    
     var t= $j(this).children('.value_variant').html();  
     $j('.selected_value').html($j(this).html());
     $j('.selected_value span').fadeOut();
     $j('.select_color').html($j(this).html());
     $j('ul.drop_down_color_box').slideToggle('slow');
    
      
    // seclect option change variant
    var i = $j(this).closest(".drop_down_color_box").attr("data-custome-index");
    var val_t = $j(this).children('.value_variant_escape').html();   
    //alert(val_t);
    $j(this).closest("form").find(".single-option-selector").eq(i).val(val_t).trigger("change");
   
    select_parent_cat(val_t);
    
  }); */
  
  function grid_variant_change($this,value,trigger = false) {
    var $grand_parent = $this.parents(".product_grid_item");
    var $parent = $this.parents(".grid-action");
    if(trigger) $this.parents(".option-group").find(".single-option-selector").val(value).trigger("change");
    var options = [];
    $parent.find(".single-option-selector").each(function(){
      options.push($j(this).val());
    });
    if(options.length) {
      var variant_title = options.join(" / ");
      var variants = JSON.parse($parent.find(".variant_json").text().trim());
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if(variants[i].title == variant_title) {
          variant = variants[i];
          break; 
        }
      }
      if(variant) {
        if(variant.available) {
          $parent.find(".add_to_cart_ajax").removeClass("disabled");
          $parent.find(".addtocart_txt").text("Add to Bag");
        } else {
          $parent.find(".add_to_cart_ajax").addClass("disabled");
          $parent.find(".addtocart_txt").text("Sold out");
        }
        $parent.find(".add_to_cart_ajax").attr("data-pid",variant.id);
        $grand_parent.find(".pro_price").html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
        if(variant.compare_at_price > variant.price) {
          $grand_parent.find(".pro_c_price").html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).show();
        } else {
          $grand_parent.find(".pro_c_price").hide();
        }
        $grand_parent.find(".v_title").html(variant.title);
      }
    }
  }
  
  $j("body").on("click", "ul.drop_down_color_box li", function(){ 
    var variant_id = $j(this).attr("data-id");
    var $parent = $j(this).parents('.selector-wrapper');
    var $selected_value = $parent.find('.selected_value');
    if($j(this).parents('.eyes_shadow_box').length)  {
      var $selected_value = $j(this).parents('.eyes_shadow_box').find('.selected_value');
    }
    var dow_h= $selected_value.height()+10;
    $selected_value.css('height', dow_h);
    $selected_value.find('span').fadeOut('fast');
      var t= $j(this).children('.value_variant').html();  
     /*setTimeout(function(){ 
 		 $j('.selected_value').html($j(this).html());
   		 $j('.select_color').html($j(this).html());
       	alert('');
 	 }, 300); */
     var vhtml = $j(this);
     html_lable(vhtml,$parent);
    
     if($j(this).parents('.eyes_shadow_box').length)  {
       $j(this).parents('.eyes_shadow_box').find('ul.drop_down_color_box').stop().slideToggle('fast');
     } else {
       $parent.find('ul.drop_down_color_box').stop().slideToggle('fast');
     }
    // seclect option change variant
    var i = $j(this).closest(".drop_down_color_box").attr("data-custome-index");
    var val_t = $j(this).children('.value_variant_escape').html();   
    var val_t1 = $j(this).children('.value_variant_escape').attr('data-vare');
    //alert(val_t);
    if($j(this).parents(".grid-action .product-form__item .option-group").length == 0) {
      $j(this).closest("form").find(".single-option-selector").eq(i).val(val_t).trigger("change");   
    } else {
      grid_variant_change($j(this),val_t,true);
      var var_image = $j(this).attr("var-image");
      if(var_image) $j(this).parents(".product_grid_item").find(".grid-view-item__image").attr("src",var_image);
    }
    select_parent_cat(val_t);

    setTimeout(() => {
    var current_btn = $j('.product-form .selected_value .value_variant').text();
    $j('.swatch_box [data-value="'+ current_btn +'"] label').trigger('click');
    },500);
    

    if($j(this).parents('ul.drop_down_color_box').hasClass('active')){
      
       $j(this).parents('ul.drop_down_color_box').removeClass('active');
    }else
    {
      $j(this).parents('ul.drop_down_color_box').addClass('active');
    }
    
    var widow_w=$j(window).width();
    if(widow_w<769){
      if($selected_value.hasClass('active')) {
        $j('body').removeAttr('style');
        $selected_value.removeClass('active');
      } else {
        if($j(this).parents(".grid-action").length === 0) {
          if($j(this).parents(".eyes-shadow-wrap.visible-sm").length === 0) $j('body').css('position', 'fixed');
        }
        $selected_value.addClass('active');
      }
    }
    
    
    html_show();
    
   // hide_show_thumb_img(val_t1);
   // val_t = val_t.replace(" - ", "-");
   // val_t = val_t.replace(/ /gi, "-");
    
    val_t = val_t.toLowerCase();
    hide_show_varaint_txt(val_t1);

    if($j(this).parents(".grid-action").length == 0) {
    
     var getts = $j(this).attr('data-varent');            
      
      reset_slider(getts);
    }

    // CD change images in zoom modal
    let imageAlt = val_t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').replace(/-+/g, '-');
    var $newImageGroup = $('.product-single__photo[data-image-alt=\'' + imageAlt + '\']');
    var $otherImageGroup = $('.product-single__photo:not([data-image-alt=\'' + imageAlt + '\'])');
    if($newImageGroup.length) {
      $newImageGroup.removeClass('hide');
      $otherImageGroup.addClass('hide');
    } else {
      $('.product-single__photo').removeClass('hide');  
    }
    
    //CD trigger custom event for shade change
    const customEvent = new CustomEvent('shadeChange', {
      detail: {
        variant_id,
        variant_title: t.toLowerCase()
      }
    });
    document.dispatchEvent(customEvent);

});
 
  function reset_slider(getts)
  {
         $j('.product_slider_custome').addClass('loading');
         $j('.product-image-block').html('');
           $j('.image-load').show();
    	   $j('#ProductThumbs-product').hide();
           
          $j.ajax({
          type: 'GET',
          url: ""+getts+"",
          dataType: "HTML",
          success: function(matt)
        {
           $j('.image-load').hide();
          $j('#ProductThumbs-product').show()
         var change =  $j(matt).find('.product-single__photos').html();
          $j('.product-single__photos').html('');
          $j(".product-single__photos").append(change);
          var intervalId = setInterval(function(){
            if($j(".product-single__photos .feature-row__image ").height() > 0) {
              $j('.product_slider_custome').removeClass('loading');
              $j('.slider_custome').slick({
                dots: true,
                adaptiveHeight: true,
                swipe: true,
                appendDots: $j('#ProductThumbs-product'),
                customPaging:function(slider, i) {  
    
                 var thumb = $j(slider.$slides[i]).data('thumb');
                  
                  //  return '<div class="abcontainer"><img class="ab" src="'+thumb+'"></div>';
                    if($j('[data-thumb="'+ thumb +'"]').hasClass('pro_video')){
                      return '<div class="abcontainer"><img class="ab" src="'+thumb+'"><span class="play_icon"></span></div>';
                    }
                    else{
                      console.log('12345',thumb)
                     if (thumb && !thumb.includes('no-image')) {
                      return '<div class="abcontainer 89654"><img class="ab" src="'+thumb+'"></div>';
                     }
                     
                    }
                }
               });
 
              $j('.slider_custome').slick('resize');

              
              if(document.querySelector('.product-single__photo-wrapper1 video source')){
                if(document.querySelector('.custom_meta_opject_section .image_main video.hide')){
                document.querySelector('.custom_meta_opject_section .image_main video').classList.remove('hide')
                }
              var current_video_src = document
                .querySelector('.product-single__photo-wrapper1 video source')
                .getAttribute('src');
              var current_video_src_poster = document
              .querySelector('.product-single__photo-wrapper1 video')
              .getAttribute('poster').replace('_small', '');
              var videoSource = document.querySelector('.custom_meta_opject_section .image_main video source[type="video/mp4"]');
              var video = document.querySelector('.custom_meta_opject_section .image_main video');
              
                videoSource.setAttribute('src', current_video_src);
                document.querySelector('.custom_meta_opject_section .image_main video').setAttribute('poster', current_video_src_poster);

              document.querySelector('.custom_meta_opject_section .video_play_icon').classList.remove('hide');
              document.querySelector('.custom_meta_opject_section .image_main video').removeAttribute('controls');

              if($('.custom_meta_opject_section').length){
                $('.custom_meta_opject_section .video_play_icon').trigger('click')
              }
              // important
              video.load();
              }else{
                document.querySelector('.custom_meta_opject_section .image_main video').classList.add('hide');
              }


              
              if ($j(window).width() > 768) {
                var thumbsheight = $j('#ProductThumbs-product ul').innerHeight();
                $j('#ProductThumbs-product').css('height', thumbsheight);
              }


              if($('.template-product.lipstick-landing').length){
                cloneDots();

                $j('.slider_custome')
                .on('init', function(){
                  cloneDots();
                })
                .on('reInit', function(){
                  cloneDots();
                })
                .on('afterChange', function(){
                  cloneDots();
                });
              }
              clearInterval(intervalId);
            }
          },300);

        /*  $j('.ProductImg-{{ section.id }}').magnificPopup({
            type: 'image',
            mainClass: 'mfp-fade',
            closeOnBgClick: true,
            closeBtnInside: false,
            closeOnContentClick: true,
            tLoading: '',
            removalDelay: 200
          }); */
       } 
        });  
  }
  function hide_show_varaint_txt(v_name)
  {  
    $j('.variant_description').hide();
    $j('.variant_description.' + v_name).show();
    
  }
  
  function hide_show_thumb_img(tag_img)
  { 
   
   var count=0;
    var aa= 0;
    $j('.thumbnails-wrapper ul li').each(function(){
      if(!aa ==0){
       if($j(this).hasClass(tag_img))
       {
         $j(this).show();
         count= count+1;
         $j(this).addClass('active');
       }
        else
        {
          $j(this).hide();
           $j(this).removeClass('active');
         }
    }else{
         aa +=1; 
         count= count+1;
      }
    });
    
    if(count>1)
    {
      $j('.next_product, .pre_product').show();
     
       
    }else
    {
      $j('.next_product, .pre_product').hide();
       
    }
     $j('.pre_product').hide();
  }
  
  load_time_show_icon();
  function load_time_show_icon()
  {  
     var atl="";
    $j('.product-single__photos .product-single__photo-wrapper').each(function(){
      if(!$j(this).children('.product-single__photo').hasClass('hide'))
    {
      atl = $j(this).find('img.product-featured-img ').attr('alt');
    //  atl ='img-tag-'+ atl;
      hide_show_thumb_img(atl);
    }
     
  });
    
  }
  
  
  function html_lable(vhtml,$parent)
  {
    setTimeout(function(){
       $parent.find('.selected_value').html($j(vhtml).html());
   		 $parent.find('.select_color').html($j(vhtml).html());
       	 $parent.find('.selected_value span').hide();
 	 }, 300);
  }
  function html_show()
  {
    setTimeout(function(){ 
 		 $j('.selected_value span').fadeIn('fast');
      
 	 }, 300);
  }

  // product description
  boer_line_width();
  
  $j('.name-box-description .tittle_acd span').click(function(){
    	var idcl = $j(this).attr('id');
       $j('.name-box-description .tittle_acd span').removeClass('active');
        $j(this).addClass('active');
  		$j('.txt-box-descriotion .product-single__description').removeClass('active');
  		$j('.txt-box-descriotion .product-single__description.'+idcl).addClass('active');
    
    	// bottom line
        var div_w = $j(this).width();    	
        var div_left = $j(this).offset().left - $j('.accoding.desktop-view').offset().left;        
    	$j('.border_line').css({"width": div_w, left: div_left});
    	
    
    });
 
  // mobile product description
  //  $j('.accoding_full-box .tittle_acd_m').click(function(){

  //   if($j(this).hasClass('active'))
  //   {
  //       $j(this).next().slideToggle();
  //       $j(this).removeClass('active');
      
  //   }else
  //   {      
  //         $j('.name-box-description .accoding_full-box').each(function(){

  //         if($j(this).children('.tittle_acd_m').hasClass('active'))
  //         {
  //           $j(this).children('.tittle_acd_m').next().slideToggle();
  //           $j(this).children('.tittle_acd_m').removeClass('active');
  //         }

  //       });
      
  //       $j(this).next().slideToggle();
  //       $j(this).addClass('active');
  //   }
        
     
  //   });
  $j('.tittle_acd_m').click(function() {

    if ($j(this).hasClass('active')) {
        $j(this).removeClass('active');
        $j(this).next().slideUp();
    } else {
        // Close all
        $j('.tittle_acd_m').removeClass('active');
        $j('.tittle_acd_m').next().slideUp();

        // Open current
        $j(this).addClass('active');
        $j(this).next().slideDown();
    }

});
  
  
  // next and pre arrow
  var next = 0;
  $j('.thumbnails-wrapper ul.product-single__thumbnails li').click(function(){
		// next
    
                  var thum_act = $j(this).index();                  
                  var thum_act_last = $j('.thumbnails-wrapper ul.product-single__thumbnails li').length;
                  var next = 0;
                  thum_act++;
                 
                  for(thum_act; thum_act <= thum_act_last; thum_act++)
                  {
                    if( $j('.thumbnails-wrapper ul.product-single__thumbnails li:eq('+thum_act+')').hasClass('active'))
                    {
                      next = 1;                      
                    }
                  }
                  if(next ==1)
                  {
                    $j('.next_product').show();
                  }else
                  {
                    $j('.next_product').hide();
                  }
    
    	 
    	// prev
    
            var prev = 0;
            var thum_act = $j(this).index(); 
              thum_act--;
            for( thum_act; thum_act >= 0; thum_act--)
            {  
              if( $j('.thumbnails-wrapper ul.product-single__thumbnails li:eq('+thum_act+')').hasClass('active'))
              {
                prev = 1;                      
              }
            } 
          
            if(prev ==1)
            {
              $j('.pre_product').show();
            }else
            {
              $j('.pre_product').hide();
            }
    
      hide_single_img();
        
  	});
  
  $j('.thumbnails-wrapper ul.product-single__thumbnails li:last-child').click(function(){
  		$j('.pre_product').show();
    	$j('.next_product').hide();
  });
   $j('.thumbnails-wrapper ul.product-single__thumbnails li:first-child').click(function(){
  		$j('.pre_product').hide();
    	$j('.next_product').show();
  });
  
  // next product arrow
  $j('.next_product span').click(function(){
    //alert("");
    var act = 0
      $j('.thumbnails-wrapper ul.product-single__thumbnails li').each(function(){

        if( act ==1)
          {
            if($j(this).hasClass('active'))
               {
                  $(this).children('a').trigger('click');
                  var thum_act = $j(this).index();                  
                  var thum_act_last = $j('.thumbnails-wrapper ul.product-single__thumbnails li').length;
                  var next = 0;
                  thum_act++;
                 
                  for(thum_act; thum_act <= thum_act_last; thum_act++)
                  {
                    if( $j('.thumbnails-wrapper ul.product-single__thumbnails li:eq('+thum_act+')').hasClass('active'))
                    {
                      next = 1;                      
                    }
                  }
                  if(next ==1)
                  {
                    $j('.next_product').show();
                  }else
                  {
                    $j('.next_product').hide();
                  }
                 $j('.pre_product').show();
               return false;
               }
          }
          else
          {

            if($j(this).children('a').hasClass('active-thumb'))
            {
                  act =1;
            }
          }
      
    });
    
    
    	//$j('.thumbnails-wrapper ul.product-single__thumbnails li a.active-thumb').parents('li').next('li').children('a').trigger('click');
    	$j('.pre_product').show();
     hide_single_img();
    	
  });
  
    $j('.pre_product span').click(function(){
      var count_tab_active = 0
      $j('.thumbnails-wrapper ul.product-single__thumbnails li').each(function(){
        
         if( $j(this).children('a').hasClass('active-thumb'))
         {
             return false;
         }                                                        
        count_tab_active++;
        
      });
    
      
      count_tab_active = count_tab_active - 1;
      
      for(var i =  0; i <= count_tab_active; count_tab_active--)
      { 
        if($j('.thumbnails-wrapper ul.product-single__thumbnails li:eq('+count_tab_active+')').hasClass('active'))
        {
          $('.thumbnails-wrapper ul.product-single__thumbnails li:eq('+count_tab_active+') a').trigger('click');
          
          
            
           var prev = 0;
            var thum_act = count_tab_active -1;
             
            for( thum_act; thum_act >= 0; thum_act--)
            {  
              if( $j('.thumbnails-wrapper ul.product-single__thumbnails li:eq('+thum_act+')').hasClass('active'))
              {
                prev = 1;                      
              }
            }
           // alert(prev);
            if(prev ==1)
            {
              $j('.pre_product').show();
            }else
            {
              $j('.pre_product').hide();
            }
           $j('.next_product').show();
            return false;
        }
      }
      
 
                                                                 
            
      //	$j('.thumbnails-wrapper ul.product-single__thumbnails li a.active-thumb').parents('li').prev('li').children('a').trigger('click');
       $j('.next_product').show();
      	 hide_single_img();
    });
 
  //.accordion support
  $j('.accordion .ac_title').click(function(){
     
    	if($j(this).hasClass('active'))
        {
          $j(this).removeClass('active');
           $j(this).next('.acc_box_txt').slideToggle();
        }
    	else
        {
          $j(this).parent('.accordion_box').parent('.accordion').children('.accordion_box').each(function(){
            
          	 if($j(this).children('.ac_title').hasClass('active'))
        		{ 
                  $j(this).children('.ac_title').removeClass('active');
          		 $j(this).children('.ac_title').next('.acc_box_txt').slideToggle();
                }
          });
             
          
           $j(this).addClass('active');
           $j(this).next('.acc_box_txt').slideToggle();
          
        
        }        
  });
  
  //image switch
  //$j('.multiple_box_ot .img_multiple').first().addClass('active');
  var sl_interval;
  $j('.multiple_box_ot').mouseover(function(){
    $j(this).addClass('active');
    
   			 var bb = $j(this);
    		sl_interval = setInterval(function(){  
              image_switch(bb);             
              
           }, 1200);
    
  });
  
  $j( ".multiple_box_ot").mouseout(function() { 
    clearInterval(sl_interval);
     $j(this).removeClass('active');
  });
  
  
  //RecoverPassword
  $j("body").on("click", "#RecoverPassword", function(){
    
   		// $j('#RecoverPasswordForm').show();
    	$j('#RecoverPasswordForm').addClass('active');
    });
    
  
  // filter
  $j('.lip_box .tittle').click(function(){
   if($j('.template-product:not(.lipstick-landing)').length){

    var window_w=$j(window).width();    
    if(window_w>768){
    	if(!$j(this).hasClass('active'))
         {
           		$j(this).addClass('active');
    	     	$j('.filler_box_itme').slideToggle();
  		 }
         else
          {
            	$j(this).removeClass('active');
    	     	$j('.filler_box_itme').slideToggle();   
          }
    }else
    {
      if(!$j(this).hasClass('active'))
         {
           		$j(this).addClass('active');           
           		$j('.filler_box_itme').css({'right': '10px','display': 'block'});
           		
  		 }
         else
          {
            	$j(this).removeClass('active');
                var filter_w = $j('.filler_box_itme').width()+10;
                filter_w= filter_w -filter_w*2;
    	     	$j('.filler_box_itme').css('right', filter_w);   
            	
          }
    }
     }else{
         if(!$j(this).hasClass('active'))
         {
           		$j(this).addClass('active');
    	     	$j('.filler_box_itme').slideToggle();
  		 }
         else
          {
            	$j(this).removeClass('active');
    	     	$j('.filler_box_itme').slideToggle();   
          }
  }
    
  });
  $j('.filler_box_itme .filler_box_itme_inner ul li').click(function(){
    	 var window_w=$j(window).width();    
    	if(window_w<769){
            $j('.lip_box .tittle').removeClass('active');
           var filter_w = $j('.filler_box_itme').width()+10;
                filter_w= filter_w -filter_w*2;
          	$j('.filler_box_itme').css('right', filter_w);
          
        }
  });
  
  
  
  $j('.filler_box_itme_inner ul li').click(function(){
    $j('.filler_box_itme_inner ul li').removeClass('active');
    $j(this).addClass('active');
    
    var c_name = $j(this).children('span').html();
    $j('.swatch_tittle .tittle .cat_name').html(c_name);
    
    var parent_color = $j(this).children('span').attr('data-attr');
    var color_names = parent_color.split(",");
    
     
    
     $j('.swatch .toggler').each(function(){
       $j(this).hide();
     });
    
    $j('.swatch .toggler').each(function(){
      if (parent_color !=0)
      {
          for(var i = 0; i<= color_names.length-1; i++)
          {
			var swatch_attr = $j(this).children(".swatch-element").attr("data-value");
            if(swatch_attr == $j.trim(color_names[i]))
            {
             	$j(this).show();
            }
          } 
      }
      else
      {
      	$j(this).show();	
      }
      
    });
     var window_w=$j(window).width();    
     if(window_w>768){
      $('.lip_box .tittle').trigger('click');
     }
    
  });
  
  // header desktop menu

  $j('li.site-nav--has-dropdown').mouseover(function(){
    	$j(this).addClass('active');
  });
  $j('li.site-nav--has-dropdown').mouseout(function(){
    	$j(this).removeClass('active');
  }); 
  $j('#SiteNav li').mouseover(function(){
     if(!$j('#SiteNav').hasClass('header_active') && $j(this).find('.site-nav__dropdown').length > 0 )
     {
      $j('.sub_menu_bar').addClass('active');
     }
     
  });
   $j('#SiteNav').mouseout(function(){
      $j('.sub_menu_bar').removeClass('active');      
  });
  

  // Header Mobile menu  
  $j('ul li.mobile-nav__item button').click(function(){ 
  //$j( 'ul li.mobile-nav__item button' ).unbind( "click", function() {
       
    	$j(this).next().slideToggle();
    	if($j(this).next().hasClass('is-transitioning'))
        {
          $j(this).next().removeClass('is-transitioning');
        }
        
  });
  $j('btn--link site-header__menu').click(function(){
    $('ul#MobileNav li.mobile-nav__item:first-child').trigger('click');
    //$j('ul#MobileNav li.mobile-nav__item:first-child').trigger('click');
  });
  
  
  
  
  // cart  
  

    $j('.cart__qty-input:not(.not_change)').on('change keyup', function() {
       var qty = $j(this).val();
      if( qty != 0)
      {
          var p_key = $j(this).parent('.cart__qty').children('.product_key').html();
           p_key= $j.trim(p_key);     
          var key = p_key.split(':');
         // alert(key['0']);
          //  

           var update_q = 'updates['+key+']='+qty;

          jQuery.ajax({
            type: "POST",
            url: '/cart/update.js',
            data: update_q,
            dataType: 'json',
            success: function(){
              location.reload();
            },
            error: function(err) {
              console.log("error",err);
            }
          });
                    

             var p_price = $j(this).parent('.cart__qty').parent('.qty_box').parent('td').children('.mone_cart_box').children('div').children('span').html();
             var one_pro_price = $j(this).parent('.cart__qty').parent('.qty_box').parent('td').children('.mone_cart_box').children('.one_product_price').html();

             if(typeof p_price !== 'undefined') {
        
                 var a = p_price?.split(' '); //$40.0 AUD
                 var cunt = a['1'];
                 var b = a['0'];
                 var c = b.split('');
                 var sign = c[0]; 
                 var pr_price = b.replace(sign, '');
    
                 // var p_sign	= p_price
    
                  var new_price = (one_pro_price/100*qty).toFixed(2);
                 /// alert(cunt);
            	  if(c[0] !=0 )
                  {
                    $j(this).parent('.cart__qty').parent('.qty_box').parent('td').children('.mone_cart_box').children('div').children('span').html(sign+new_price);
                  }else
                  {
                   $j(this).parent('.cart__qty').parent('.qty_box').parent('td').children('.mone_cart_box').children('div').children('span').html(sign+new_price+' ' +cunt );
                  }
             }
          //sub total
          var old_sub_total = $j('.cart__subtotal .money').html();
  
          if(typeof old_sub_total !== 'undefined') {
             var o_a = old_sub_total.split(' '); //$40.0 AUD
             var o_cunt = o_a['1'];
             var o_b = o_a['0'];
             var o_c = o_b.split('');
             var o_sign = c[0]; 
             var o_pr_price = o_b.replace(o_sign, '');


            var new_sub_total = parseFloat(o_pr_price) - parseFloat(pr_price);
             new_sub_total = parseFloat(new_sub_total) + parseFloat(new_price);
            new_sub_total =(new_sub_total).toFixed(2);
            if(c[0] !=0)
            {
              $j('.cart__subtotal .money').html(sign+new_sub_total );
            }else
            {
              $j('.cart__subtotal .money').html(sign+new_sub_total+' ' +cunt );
            }
          } 
          
      }else
      {
        	var removeproduct =  $j(this).parents('.cart__qty').parents('.qty_box').parents('td').parents('tr').children('td.cart__meta').children('.small--hide').children('.cart__remove').attr("href");            
        	//alert(removeproduct);
          window.location.replace(removeproduct);
      }
      
    }); 

  
  
  // hover collection
  $j('.collection-grid-item').mouseover(function(){
  		//hover_text_box
       var window_w = $j(window).width();
    	if(window_w > 769){
          var hover_color = $j(this).find('.hover_text_box').attr('data-hover');
          $j(this).find('.hover_text_box').css('color', hover_color); 
        }
  });
  $j('.collection-grid-item').mouseout(function() {
    
     var window_w = $j(window).width();
    	if(window_w > 769){
            var hover_color = $j(this).find('.hover_text_box').attr('data-color');
           // alert(hover_color);
            $j(this).find('.hover_text_box').css('color', hover_color); 
        }
  });
  
  
  
  // load proudct
  var noofproduct=0;
  $j('.collection-inner .grid__item--product-template-variant').each(function(){  // .template-collection .collection-inner .grid__item--collection-template
    	if(noofproduct<16)
        {
          $j(this).show();
          $j(this).addClass('active');
          noofproduct++;
        }
    	show_load_more_btn();	
    
  });
  
  $j('.load_more_box a').click(function(e){
     var noofproduct=0;
      $j('.collection-inner .grid__item--product-template-variant, .template-collection .collection-inner .grid__item--collection-template').each(function(){
        
        if(!$j(this).hasClass('active'))
          {
              if(noofproduct<16)
              {
               // $j(this).show();
                $j(this).slideToggle('fast');
                $j(this).addClass('active');
                noofproduct++;
              }                            
     	  }
    });
    
    show_load_more_btn(); 
    e.preventDefault();    
  });
  
  
  
   $j(".instgram-slider-img a").on('click', function(e) {
     e.preventDefault();
     
     var target = $j(this).attr('href');
     $j('html, body').animate({
       scrollTop: ($j(target).offset().top)
     }, 2000);
  });
  
  
  
  // add to cart
  /*$j('.btn_home_add_to_cart').click(function(e){
    $j(this).children('span').html('Adding');
      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: 446784176151
        
      });
     
    $j(this).children('span').html('Added');
   //$j(this).children('span').html( ); 
    e.preventDefault();
  }); */
  
 
   product_slider_size(); 
  
  
   $j("body").on("click", ".mobile_slider_product .collection-grid-item-mcart", function(){
     	//var trg_url =$j(this).attr('href');
   });
  
  $j("body").on("click", ".mobile_slider_product .collection-grid-item-mcart", function(){
		var trg_url= $j(this).children('a').attr('href');
    	//alert(trg_url);
});
 
 product_thumb_img();
  
 header_fix(); 
});

 function hide_single_img()
  {
      var total = 0;
      var acttot = 0;
      $j('.product-single__thumbnails li').each(function(){
        if($j(this).attr('style'))
        {
          acttot += 1;
        } 
           total +=1;

      });
      if(total ==1 || acttot==1)
      {
        $j('.next_product').hide();
         $j('.next_product').hide();
      }
  }

  function boer_line_width()
  {
      var bdl = $j('.desktop-view .name-box-description #description-hd.active').width();
    $j('.border_line').css( "width", bdl);
  }
function show_load_more_btn()
{
  var act = 0;
  $j('.collection-inner .grid__item--product-template-variant, .template-collection .collection-inner .grid__item--collection-template').each(function(){
       if(!$j(this).hasClass('active'))
          {
            	act=1;
          }
     });
  if(act == 0)
  {
    $j('.load_more_box').fadeOut();
  }else
  {
    $j('.load_more_box').show();
    $j('.pre_product').show();
  }
  
}


function select_parent_cat(color_name)
{
  $j('.filler_box_itme_inner ul li').removeClass('active');
  $j('.filler_box_itme_inner ul li').each(function(){
    var parent_color = $j(this).children('span').attr('data-attr');
    var color_names = parent_color.split(",");
    
      for(var i = 0; i<= color_names.length-1; i++)
          {
			var swatch_attr = $j(this).children(".swatch-element").attr("data-value");
            if( color_name == $j.trim(color_names[i]))
            {
             	$j('.swatch_tittle .tittle .cat_name').html($j(this).children('span').html());
              	$j(this).addClass('active');
              	return false;
            }
          }
    
    
  });
}

function image_switch(ida){
	
     		if( $j(ida).hasClass('active')){
              
              		var act=1
                     $j(ida).children(".img_multiple").each(function(){
                   
                       if(act==1){
                         
                             if($j(this).hasClass('active'))
                            {
                                  if( !$j(this).next().hasClass('img_multiple'))
                                  {
                                    //alert("first");
                                    $j(this).removeClass('active');
                                    $j(this).parent('.multiple_box_ot').children('.img_multiple').first().addClass('active');
                                    act=0;
                                    return false;
                                    
                                  }
                                  else
                                  {
                                    $j(this).removeClass('active');
                                    $j(this).next().addClass('active');
                                    act=0;
                                    return false;
                           		  }	

                            }
                       }
  
			});
            }
}

function select_dp_option(t, $this = null){ 
  var $color_options = $j('ul.drop_down_color_box li');
  if($this != null) {
    $color_options = $this.parents("form").find("ul.drop_down_color_box li");
  }
  
  $color_options.each(function(){
    if($j(this).parents('.grid-action').length === 0) {
      if($j(this).children('.value_variant').html() == t) {
        var current_t= $j(this).html();
        if($this != null) {
          $this.parents("form").find('.selected_value').html(current_t);   
          $this.parents("form").find('.select_color').html(current_t);
        } else {
          $j('.selected_value').html(current_t);   
          $j('.select_color').html(current_t);
        }
      }
    }
  });
    
      if(t != '' && typeof  t !='undefined')
      {
          t = t.replace(" - ", "-");
          t = t.replace(" ", "-");
         t = t.toLowerCase();
         $j('.variant_description.' + t).show();
      }
  }

function product_slider_size()
{
  var window_w = $j(window).width();
  var left_w= (window_w-270)/2;
  var left_p= left_w - left_w*2;
  left_w =left_w +10;
  left_p = left_p-10;
  window_w = window_w + 60;
 // $j('.mobile_slider_product .bx-viewport').css({'width': window_w, 'padding-left': left_w, 'margin-left': left_p});
 
  
}

 
$j(window).scroll(function(){
   product_slider_size();  
   boer_line_width();
    var scroll_w = $j(window).scrollTop();
  if(scroll_w > 50){ 	
  
  		
     if($j('#min-cart #min-cart_a').hasClass('active'))     
        { 
          /* $j('#min-cart').children('.cart_popup').hide();
           $j('#min-cart').children('.cart_popup').slideToggle();
           $j('#min-cart img').removeClass('active');
           $j('.full_scree_fade').hide();
           $j('.full_scree_fade').fadeOut(); 
           */
         // $j('.full_scree_fade').css('top', '0');
           
           $('#min-cart #min-cart_a').trigger('click');
        }
  }else
  {
    if($j('.header_txt_account spna').hasClass('active'))
    {
    // $j('.full_scree_fade').css('top', 'auto');
    }
   /* if($j('#min-cart #min-cart_a').hasClass('active'))     
    {
      $j('.full_scree_fade').css('top', 'auto');
    } */
  }
	
  	if($j('.header_txt_account spna').hasClass('active'))
         {
           
          /* $j('.header_txt_account spna').removeClass('active');
           $j('.login_popup').slideToggle();
          // $j('.login_popup').hide();
          // $j('.full_scree_fade').hide();
           $j('.full_scree_fade').fadeOut();
          // $j('.full_scree_fade').css('top', '0'); */
           
			$('.header_txt_account spna').trigger('click');
         }
  
  
 });

$j(window).on("load",function(){
  
  
  // contact us
  
  product_thumb_img();
  
 setTimeout(function(){ 
 	 instagram_slider();   
       // show review                
       $j('.review_box').show();    
     add_textto_currency();
   contact_form();
  }, 3000);
  
  var right=0;
  $j("body").on("click", ".paging li", function(){
   	  var screen_width =  $j(window).width();  
  	  var inst_feed_wth = $j('#insta-feed').width();
    if(!$j(this).hasClass('active'))
    {
      var note= $j('.paging li').index(this);
     
      var activ_not=0;
    
      $j('.paging li').each(function(){
        	
			if($j(this).hasClass('active'))
            {
              activ_not = $j('.paging li').index(this); 
            }
        
      });
      
     // alert(activ_not);
      if(note > activ_not)
      {
         // next
          right=right+screen_width;
          if( inst_feed_wth > (right + screen_width))
          {        
             $j('#insta-feed').css({'right':  right+"px"});
          }
          else
          {

            var cus_left= inst_feed_wth - right;
            right= right-screen_width;
            right=right+cus_left;
            $j('#insta-feed').css({'right': right+'px'});
          }
           $j('.paging li').removeClass('active');
           $j(this).addClass('active');
      }else
      { 
          right=right-screen_width;
          if( right > 0)
          {        
             $j('#insta-feed').css({'right':  right+"px"});
          }
          else
          {            
            right=right+screen_width;
            var cus_left= inst_feed_wth - (right+screen_width);
            right=0;
            $j('#insta-feed').css({'right': cus_left+'px'});
          }
           $j('.paging li').removeClass('active');
           $j(this).addClass('active');
      	// prev
      }
                                     
    }
    
    
    
    });
  
  // hide loader
  $j('.loading_div').fadeOut();
  
  
  
  // contact page
  setTimeout(function(){ 
   //contact_req();
  }, 4000);
});
$j(function() {
  setTimeout(function() {
    if($j('.loading_div').is(':visible')) {
      $j('.loading_div').fadeOut();
    }
  }, 3000);
});

function contact_req()
{
 
	 $j('form.esc--form select').after('</span>');
    $j('form.esc--form select').before('<span class="select_required">*');
  
}

function contact_form()
{
	$j('.esc--form  input[type="submit"]').val('Send this');
  
   $j('.contact-page-form form .esc--field-wrap').each(function(){
   var orderno = $j(this).find('label').html();
    if(orderno == 'order no'){
      $j(this).closest('.esc--field-wrap').addClass('required order_no');     
        // $j(this).find('input').attr('type', 'number');
       $j(this).find('input').attr("pattern", "^[a-zA-Z0-9]{2,}$j");
      return;
    }
    
  });
  
}

function add_textto_currency()
{
  $j('ul.currencyList').prepend('<li class="currency_top">Select Your Preferred Currency Below</li>');
}

function instagram_slider()
{
   var i=0
  	$j('#insta-feed .container').each(function(){  	
  		i++;
   });
   var itme_width = $j('#insta-feed .container').width();                    
   var width_inst = (itme_width+35)*i;
   var screen_width =  $j(window).width();
   var noofslider = width_inst / screen_width ;
   var noofsliders =noofslider.toPrecision(1);
  // alert(noofsliders);
     var dot ='<li class="dot"><span></span></li>';
     var dot_html='';
   if( noofslider > noofsliders )
   {
    
        for(var j=-1; j < noofsliders; j++ )
        {
          dot_html=dot_html + dot;           
        }
     	
     	$j('.paging').html(dot_html);
   }
   else
   {
   		
   		 for(var j=0; j <  noofsliders; j++ )
        {
          dot_html=dot_html+dot;
        }
        $j('.paging').html(dot_html);
   }
   
   $j('.paging li:first-child').addClass('active');
   $j('#insta-feed').css('width', width_inst);
}

function header_fix()
{
  var window_w = $j(window).width();
  if(window_w<769)
  {
    
    $j('.page-container').css('padding-top', $j('#shopify-section-header').height()+'px');
  }
}

$j(window).resize(function(){

  	instagram_slider();
    header_fix();
	product_thumb_img();
    product_img_slider();
    
 	 product_img_padidng_top();
	product_thumb_img();
  
   
      stop_video();
    
  
     
});


function stop_video()
{
  var w_width = $j(window).width();
  if(w_width<768)
  {
      $j(".txt-box-descriotion .product-descr-box").each(function(){
         var video = $j(this).children("iframe").attr("src");
          if(typeof video !== 'undefined'){
              $j(this).children("iframe").attr("src","");
              $j(this).children("iframe").attr("src",video);
           }
  		});
  }else
  {
    $j(".accoding .product-descr-box").each(function(){
       var video = $j(this).children("iframe").attr("src");
      if(typeof video !== 'undefined'){
          $j(this).children("iframe").attr("src","");
          $j(this).children("iframe").attr("src",video);
      }
    });
  }
 
}

function product_thumb_img()
{
  var img_w = $j('img.product-single__thumbnail-image').width();
  $j('img.product-single__thumbnail-image').css('height', img_w);
  
}

function product_img_slider()
{
  var noofimg = 0;

  $j('.product-single .product-single__photos .product-single__photo-wrapper').each(function(){
    	$j(this).removeAttr('style');
  });
   if($j(window).width()>769)
   {
      $j('.product-single .product-single__photos .product-single__photo-wrapper').each(function(){
        //noofimg = noofimg+1;
        noofimg= $j(this).offset().top - $j('.product-single').offset().top;
        noofimg = noofimg - noofimg - noofimg;
        $j(this).css('margin-top', noofimg);
        noofimg = 0;
      });
   }
  
}

function remove_effict()
  {
     var attr=$j('.currency_convert_box li').attr('style');
    if (typeof attr !== typeof undefined && attr !== false){
      
      	$j('.currency_convert_box li').removeAttr('style');
    }
    else{
    	$j('.currency_convert_box li').css({'transition-duration': 'unset', 'transition-delay': 'unset'});
    }
  }
function product_img_padidng_top()
{
  /* if($j(window).width()<768){
     var img_height = $j('.product-single .product-single__photos .product-single__photo-wrapper img.product-featured-img').height();
  $j('.product-single .product-single__photos .product-single__photo-wrapper').each(function(){
   // var img_height = $j(this).children('.product-single__photo').find('img.product-featured-img').height(); 
      $j(this).children('.product-single__photo').css('padding-top', img_height+'px');
      // insta icon
    //var outer_w = $j(this).children('.product-single__photo').width();
  //  var pro_w = $j(this).children('.product-single__photo').find('img.product-featured-img').width();
   // console.log(pro_w);
     //$j(this).find('.instgram-slider-img').
  });
   }else
   {
     $j('.product-single .product-single__photos .product-single__photo-wrapper').each(function(){
   // var img_height = $j(this).children('.product-single__photo').find('img.product-featured-img').height(); 
      $j(this).children('.product-single__photo').css('padding-top', 150+'%');
     
  });
     
     
    
     
   } */
  
}

function product_thumb_img()
{
   var img_width = $j('.product-single .product-single__photos .product-single__photo-wrapper').width();
   $j('.thumbnails-wrapper').css('width', img_width);
   //product_thumb_img_width();
}
function product_thumb_img_width()
{
   $j('.thumbnails-wrapper ul li').each(function(){
      var img_w= $j(this).children('a').find('img.product-single__thumbnail-image').width();
     $j(this).children('a').find('img.product-single__thumbnail-image').css('heigth', img_w);
     console.log(img_w);
   });
  
}
/**************JT***Product qty************/
 jQuery('.plus,.minus').click(function(){
      if(jQuery(this).data('action')=='inc')
      {
        var currentValue=jQuery('.qty').val();
        var newVal=(parseInt(jQuery('.qty').val())+1);
        jQuery('.qty').val(newVal);
      }
      else if(jQuery(this).data('action')=='dec')
      {
        var currentValue=jQuery('.qty').val();
        if(currentValue>1)
        {
          var newVal=(parseInt(jQuery('.qty').val())-1);
          jQuery('.qty').val(newVal);
        }
      }
		var neewqtyy= $j('.qty').val();
    $j('#Quantity').val(neewqtyy);  
    });
jQuery('.qty').keyup(function(){
  $j('#Quantity').val(jQuery(this).val());


});
/**************JT***END Product qty************/
/**************JT***Cart qty************/
jQuery('.cartplus,.cartminus').click(function(){
  if(jQuery(this).data('action')=='inc'){
    var currentValue=jQuery(this).parents('.cart__qty').children('.cart__qty-input').val();
    var newVal=(parseInt(currentValue)+1);
    jQuery(this).parents('.cart__qty').children('.cart__qty-input').val(newVal);
    $j('.cart__qty-input').trigger("change");
  }
  else if(jQuery(this).data('action')=='dec')
  {
    var currentValue=jQuery(this).parents('.cart__qty').children('.cart__qty-input').val();
    if(currentValue>1)
    {
      var newVal=(parseInt(currentValue)-1);
       jQuery(this).parents('.cart__qty').children('.cart__qty-input').val(newVal);
      $j('.cart__qty-input').trigger("change");
    }
  }
});
/**************JT***Cart qty************/
$j(document).ready(function(){
if ($j(window).width() > 768) {
  var thumbsheight = $j('#ProductThumbs-product ul').innerHeight();
  $j('#ProductThumbs-product').css('height', thumbsheight);
}
});



document.addEventListener('click', function(event) {
  if(document.querySelector('.cart_popup')){
    if(event.target.closest(".cart_popup .login-box-innner") == null && event.target.closest('.site-header__cart') == null){
      // console.log("callll,l", event.target)
      document.querySelector('#min-cart_a').classList.remove('active'); 
      document.querySelector('.cart_popup').style.display = "none";
       document.querySelector('.full_scree_fade').style.display = "none";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.open_popup')) {
      document.querySelector('.open_popup').addEventListener("click", function () {
        document.querySelector('.popup_overlay').style.display = "flex";
      });
    }

    if(document.querySelector('.close_popup')) {
      document.querySelector('.close_popup').addEventListener("click", function () {
        document.querySelector('.popup_overlay').style.display = "none";
      });
    }

    if(document.querySelector('.popup_overlay')) {
      document.querySelector('.popup_overlay').addEventListener("click", function (event) {
        if (event.target === document.querySelector('.popup_overlay')) {
          document.querySelector('.popup_overlay').style.display = "none";
        }
      });
    }
  });


  $(document).ready(function(){
    if(window.screen.width <= 768 && $('.lipstick_landing_product .tittle-1').length){
      $('.tittle-1').trigger('click');
    }


    if($('.custom_meta_opject_section').length){
      $('.custom_meta_opject_section .video_play_icon').trigger('click')
    }



    if($('#ProductThumbs-productt').length){
      var current_height = $('.slider_custome').height() + 10;
      document.querySelector('#ProductThumbs-productt .slick-dots').style.setProperty('top', current_height + 'px', 'important');
    }
  })